import Partner from "./partner";
import Partner1 from "../../../assets/partner1.webp";
import Partner2 from "../../../assets/partner2.webp";
import Partner3 from "../../../assets/partner3.webp";
import Partner4 from "../../../assets/partner4.webp";
import Partner5 from "../../../assets/partner5.webp";
import Partner6 from "../../../assets/partner6.webp";
import PartnerIcon from "../../../assets/partnericon.webp";

const Partners = () => {
    return (
        <div className="partners-container">
            <div className="partners-header">
                <div className="dash"></div>
                <h3>Why Partner With Us</h3>
            </div>
            <div className="partners">
                <Partner
                    img1={Partner1}
                    img2={PartnerIcon}
                    title={"Passion for Innovation"}
                    desc={"Our team thrives on solving complex problems, staying updated and finding creative solutions that drive real impact on your business."}
                />

                <Partner
                    img1={Partner2}
                    img2={PartnerIcon}
                    title={"Client-Centric Processes"}
                    desc={"We don't just listen; we understand. Your objectives become our objectives, and your success is our primary concern."}
                />

                <Partner
                    img1={Partner3}
                    img2={PartnerIcon}
                    title={"Proven Expertise"}
                    desc={"With a team of seasoned experts and outstanding track record , we bring extensive industry knowledge and technical expertise to the table."}
                />

                <Partner
                    img1={Partner4}
                    img2={PartnerIcon}
                    title={"Tailored Solutions"}
                    desc={"We offer tailored solutions designed to address your unique challenges and objectives, to deliver precisely what you need."}
                />

                <Partner
                    img1={Partner5}
                    img2={PartnerIcon}
                    title={"Catalysts for Transformation"}
                    desc={"Our purpose is to propel your business into the digital era, facilitating growth and success at every step."}
                />

                <Partner
                    img1={Partner6}
                    img2={PartnerIcon}
                    title={"Inspired By Your Success"}
                    desc={"We measure our achievements by the impact we make on your business. Our passion lies in seeing your success in the digital landscape."}
                />
            </div>
        </div>
    )
}

export default Partners